// @flow

import { connect } from "react-redux";

import Dialog from "src/components/chatroom/Dialog";
import { closeConversationModal } from "src/actions/chatroom";
import * as actions from "src/actions";

import type { AppState } from "src/types";

const mapStateToProps = ({ app }: { app: AppState }) => ({
  show: app.conversationModal.show,
  warn: app.conversationModal.warn,
  roomId: app.conversationModal.roomId
});

export default connect(mapStateToProps, { ...actions, closeConversationModal })(
  Dialog
);
